import { staticText } from '../../../utils/translations/staticText';

export const money101Translation = staticText({
  sta_bka_bank_gift: {
    _: `Provider Gift - On Top of Money101`,
    zh: '銀行優惠',
  },
  bank_gift: {
    _: `Bank Gift - On Top of Money101`,
    zh: '銀行優惠',
  },
  apply_through: {
    _: 'Apply through SingSaver and choose from :count premium rewards',
    zh: '透過 Money101 申請，享獨家通路好禮！ :count 項好禮擇一',
  },
  apply_through_ci: {
    _: 'Apply through SingSaver and choose from <b>:count premium rewards:</b>',
    zh: '透過 Money101 申請，享獨家通路好禮！ <b>:count 項好禮擇一:</b>',
  },
  apply_through_stk_bka: {
    _: 'Apply through Money101 and choose from :count premium rewards (Actual Gift eligibility depends on the deposit amount provided in the terms and conditions)',
    zh: '透過 Money101 申請，享獨家通路好禮！ :count 項好禮擇一',
  },
  purchase_through: {
    _: 'Purchase through SingSaver and choose from :count premium rewards',
    zh: '透過 Money101 購買，享獨家通路好禮！ :count 項好禮擇一',
  },
  brand_take: {
    _: `Money101's take`,
    zh: 'Money101 產品分析',
  },
  brand_reward: {
    _: 'Money101 Reward',
    zh: 'Money101 獨家好禮',
  },
  bank_gift_info: {
    _: `You’ll also receive the following welcome gift(s) directly from the bank`,
    zh: `此產品享有以下限時優惠`,
  },
  full_reward: {
    _: 'See the full reward and offer details',
    zh: '查看更多優惠詳情',
  },
  provider_gift_info: {
    _: `You'll also receive the following welcome gift(s) directly from the provider`,
    zh: `此產品享有以下限時優惠`,
  },
  loan_amount_exclusive: {
    _: `For a :product of :currency:amount over :tenure months, you’ll enjoy via :brand`,
    zh: `以 :product 申請 :currency:amount，分 :tenure 個月攤還，申辦及達指定條件即享有以下優惠`,
  },
  update_amount_tenure: {
    _: 'Update Loan Amount / Tenure to Qualify',
    zh: '調整貸款金額／還款期限以符合優惠資格',
  },
  amount_tenure_price_unlock_reward: {
    _: 'Update your loan amount to at least <b>:prefix:amount</b> and loan tenure to at least <b>:tenure month</b> to unlock exclusive gifts worth up to <b>:prefix:maxReward</b>.',
    zh: '請將貸款金額調整至至少 <b>:prefix:amount</b>，並將還款期限延長至至少 <b>:tenure 個月</b>，達成指定條件即可獲得最高 <b>:prefix:maxReward</b> 專屬好禮。',
  },
  amount_tenure_unlock_reward: {
    _: 'Update your loan amount to at least <b>:prefix:amount</b> and loan tenure to at least <b>:tenure month</b> to unlock exclusive gifts',
    zh: '請將貸款金額調整至至少 <b>:prefix:amount</b>，並將還款期限延長至至少 <b>:tenure 個月</b>，達成指定條件即可獲得專屬好禮。',
  },
  amount_unlock_reward: {
    _: 'Update your loan amount to at least <b>:prefix:amount</b> to unlock exclusive gifts',
    zh: '請將貸款金額調整至至少 <b>:prefix:amount</b>，達成指定條件即可獲得專屬好禮。',
  },
  tenure_unlock_reward: {
    _: 'Update your loan tenure to at least <b>:tenure month</b> to unlock exclusive gifts',
    zh: '請將還款期限延長至至少 <b>:prefix:amount</b>，達成指定條件即可獲得專屬好禮。',
  },
  worth_up_reward: {
    _: '<b>worth up to :prefix:reward</b>',
    zh: '<b>:prefix:reward 專屬好禮。</b>',
  },
  brand_reward_guidance: {
    _: 'Money101 Reward',
    zh: 'Money101 貼心提醒',
  },
});
